export enum AccessLevel {
  ReadWrite = "rw",
  ReadOnly = "ro"
}
